import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {LanguageService} from '../../services/language.service';
import {CardConditionService} from '../../services/card-condition.service';
import {WarehouseService} from '../../services/warehouse.service';
import {CardStockService} from '../../services/card-stock.service';
import {Observable} from 'rxjs/Observable';
import {CardDetailedInformation} from '../../core/entities/entities';
import {ComponentBase} from '../../core/entities/component-base';

@Component({
  selector: 'app-card-stock-detail',
  templateUrl: './card-stock-detail.component.html',
  styleUrls: ['./card-stock-detail.component.css']
})
export class CardStockDetailComponent extends ComponentBase implements OnInit {

  cardId: string;
  cardStockDetail: CardDetailedInformation;

  get warehouses() {
    return Observable.create((observer:any) => { this._warehouseService.dataChange.subscribe(ret => observer.next(ret.filter(w => !w.refill)));});
  };

  get languages() {
    return this._languageService.dataChange;
  };

  get conditions() {
    return this._cardConditionService.dataChange;
  };

  defaultFilters = {
    language: undefined,
    condition: undefined,
    warehouse: undefined,
    foil: undefined,
    signed: undefined,
    stamped: undefined,
    inked: undefined,
    altered: undefined
  };

  filters = Object.assign({},this.defaultFilters)  ;

  constructor(private _cardStockService: CardStockService,
              private _route: ActivatedRoute,
              private _languageService: LanguageService,
              private _warehouseService: WarehouseService,
              private _cardConditionService: CardConditionService) {
    super();
    this.spinnerService.show();
    this._route.params.subscribe(params => {
      this.cardId = params['cardId'];

      this.load();
    });

  }

  ngOnInit() {
  }

  load() {

    this._cardStockService.getDetail(this.cardId).subscribe(result => {
      this.cardStockDetail = result;
      this.spinnerService.hide();
    });
  }


  clearFilters() {
    this.filters = Object.assign({},this.defaultFilters);
  }

  applyFilters() {
    this.spinnerService.show();
    this._cardStockService.getDetail(this.cardId, this.filters).subscribe(result => {
      this.cardStockDetail = result;
      this.spinnerService.hide();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/home/card-stock-detail/card-stock-detail.component.ts